import { AxiosResponse } from 'axios';
import api from './Api'

export const getWeekListByIsShow = (): Promise<AxiosResponse<Array<any>>> => {
    return api.get(`/mobile/week/isShow`);
}